/**
 * Customer locked-gate PIN for dumpster drop.
 * Stored in requested_notes as "Locked gate: 1234".
 * Hauler / driver sees the digits only after they accept the job.
 */

export const WM_LOCKED_GATE_NOTE_LABEL = 'Locked gate';
export const WM_LOCKED_GATE_MIN_DIGITS = 4;
export const WM_LOCKED_GATE_MAX_DIGITS = 6;
export const WM_LOCKED_GATE_REDACTED = 'Locked gate: (shown after you accept this job)';

export function wmNormalizeLockedGateCode(raw?: string | null): string {
  return String(raw || '').replace(/\D/g, '').slice(0, WM_LOCKED_GATE_MAX_DIGITS);
}

export function wmLockedGateCodeIsValid(raw?: string | null): boolean {
  // Count unsliced digits so "1234567" is invalid — do not treat a sliced 6 as ok.
  const digits = String(raw || '').replace(/\D/g, '');
  return digits.length >= WM_LOCKED_GATE_MIN_DIGITS && digits.length <= WM_LOCKED_GATE_MAX_DIGITS;
}

export function wmFormatLockedGateNoteLine(raw?: string | null): string | null {
  const digits = wmNormalizeLockedGateCode(raw);
  if (!wmLockedGateCodeIsValid(digits)) return null;
  return `${WM_LOCKED_GATE_NOTE_LABEL}: ${digits}`;
}

export function wmExtractLockedGateCode(notes?: string | null): string | null {
  const m = String(notes || '').match(/^Locked gate:\s*([0-9]{4,6})\s*$/im);
  return m ? m[1] : null;
}

export function wmRedactLockedGateInNotes(notes?: string | null): string {
  return String(notes || '').replace(
    /^Locked gate:\s*.+$/gim,
    WM_LOCKED_GATE_REDACTED,
  );
}

/** After accept (assigned+) the hauler may see the PIN. Customer always may. */
export function wmJobRevealsLockedGate(status?: string | null): boolean {
  const s = String(status || '');
  if (!s || s === 'requested' || s === 'cancelled') return false;
  return true;
}
